import InherentRisksList from './InherentRisksList';
export default InherentRisksList;
